import { heroEquipment } from "../HeroEquipment";

export const sybaryci = {
  heroes: {
    Wtajemniczony: {
      id: 0,
      startingEquipment: ["Sztylet", "Bicz"],
      cost: 75,
      number: 1,
      equipmentList: heroEquipment["Kult Sybarytów"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Czarnoksięstwo",
        "Dowódca",
        "Mag (Dziedzina Slaanesha)",
        "Stygmat Chaosu",
      ],
      exp: 20,
      skills: [0, 1, 2, 4, 5],
    },
    Akolita: {
      id: 1,
      startingEquipment: ["Sztylet", "Rapier"],
      cost: 35,
      number: 2,
      equipmentList: heroEquipment["Kult Sybarytów"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Stygmat Chaosu", "Uwodzenie"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Opętany: {
      id: 2,
      startingEquipment: ["Broń naturalna"],
      cost: 180,
      number: 1,
      equipmentList: {},
      type: "Bohater",
      stats: {
        Początkowa: [5, 3, 0, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 7, 0, 5, 5, 4, 5, 5, 10],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Furia",
        "Głód trzewi",
        "Ograniczony",
        "Opętany",
        "Przepastne trzewia",
        "Strach",
        "Tempy",
        "Wielkolud",
        "Żywiołak Chaosu",
      ],
      exp: 8,
      skills: [0, 1, 3, 4, 5],
    },
    Kultysta: {
      id: 3,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 12,
      equipmentList: heroEquipment["Kult Sybarytów"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści", "Żywa tarcza"],
    },
    "Bólożądna pieszczota": {
      id: 4,
      startingEquipment: ["Broń naturalna (szybki)"],
      cost: 45,
      number: 3,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 0, 4, 3, 1, 5, 3, 8],
        Maksymalna: [5, 4, 0, 4, 3, 1, 5, 3, 8],
      },
      rules: ["Demon","Niepokojący","Stygmaty Slaanesha (ogon skorpiona, ponętny, szczypce)"],
    },
    Slaangor: {
      id: 5,
      startingEquipment: ["Sztylet", "Broń wielka"],
      cost: 50,
      number: 3,
      equipmentList: heroEquipment["Kult Sybarytów"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 3, 4, 4, 1, 4, 1, 7],
        Maksymalna: [6, 7, 6, 4, 5, 4, 6, 4, 9],
      },
      rules: ["Niepokojący", "Ranger", "Stygmat Chaosu"],
    },
    "Ogr Chaosu": {
      id: 6,
      startingEquipment: ["Broń wielka"],
      cost: 180,
      number: 1,
      equipmentList: heroEquipment["Kult Sybarytów"].Ogr,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Ograniczony",
        "Przepastne trzewia",
        "Strach",
        "Stygmat Chaosu",
        "Tempy",
        "Wielkolud",
      ],
    },
    Zaprzęg: {
      id: 8,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        "Powóz": ["-","-","-",4,8,8,"-","-","-"],
        "Rumak Chaosu": [8,3,0,4,"-","-",3,1,5],
        "Rumak Chaosu ": [8,3,0,4,"-","-",3,1,5]
      },
      rules: ["Duży cel", "Kontakty handlowe (3)", "Machina wojenna", "Powóz"],
    },
  },
  limit: 600,
  minModels: 3,
  maxModels: 12,
  name: "Kult Sybarytów",
  nature: "Chaotyczna",
  armyRules: ["Kontakty handlowe (1)","Niewolnicy ciemności","Oko Chaosu","Rozrzutność","Zamożność","Znak chaosu (wyznawcy slaanesha)"],
  mercenaries: [
    "Gladiator",
    "Poszukiwacz złota",
    "Rozbójnik",
    "Rycerz najemny",
    "Skryba",
    "Szpieg",
    "Trefniś",
    "Woźnica",
    "Wróżbita",
    "Złodziej",
    "Zwadźca",
  ],
};
